import L from 'leaflet'

import { getChache, setChached } from '../../util/localStorage'

const iconsReady = {}
const iconsPending = {}

export async function prepareAll(urlArray) {
    await Promise.all(
        urlArray.map(url => fetchIcon(url)),
    )
}

export function getIcon(url) {
    if (iconsReady[url]) {
        return iconsReady[url]
    }

    const iconData = getChache(url)
    if (iconData) {
        const { width, height } = iconData

        iconsReady[url] = createIcon(url, width, height)

        return iconsReady[url]
    }

    return null
}

export async function fetchIcon(url) {
    const icon = getIcon(url)

    if (icon) {
        return Promise.resolve(icon)
    }

    if (!iconsPending[url]) {
        iconsPending[url] = getImgSize(url)

        iconsPending[url].then(({ width, height }) => {
            iconsReady[url] = createIcon(url, width, height)
        })
    }

    return iconsPending[url]
}

async function getImgSize(url) {
    const img = document.createElement('img')

    img.src = url
    img.style.maxWidth = '32px'
    img.style.maxHeight = '32px'
    img.style.position = 'absolute'
    img.style.visibility = 'hidden'
    window.document.body.append(img)

    const imgSize = await new Promise((resolve) => {
        img.onload = () => {
            const { width, height } = img

            resolve({ width, height })
        }

        img.onerror = (e) => {
            // eslint-disable-next-line no-console
            console.error(e)

            resolve({
                width: 32,
                height: 32,
            })
        }
    })

    img.remove()

    setChached(url, imgSize)

    return imgSize
}

function createIcon(url, width, height) {
    return L.icon({
        iconUrl: url,
        iconSize: [width, height],
        iconAnchor: [width / 2, height / 2],
        popupAnchor: [0, -height / 2],
    })
}
